import Link from "next/link";

interface HeroProps {
    title: string;
    subtitle?: string;
    date?: string;
    showPublishedLabel?: boolean;
    categories?: {
        slug: {
            current: string;
        };
        _id: number;
        title: string;
    }[];
}

export default function Hero({
    title,
    date,
    subtitle,
    categories,
    showPublishedLabel,
}: HeroProps) {
    return (
        <section className={`blog-header ${!categories && "bg-gray-light"}`}>
            <div
                className={`pt-10 pb-10 md:pt-28 ${
                    categories ? "md:pb-16" : "md:pb-28"
                } text-center max-w-screen-sm m-auto px-6 lg:px-0`}
            >
                <p className="font-light text-gray-dark">
                    {showPublishedLabel && <span>Objavljeno: </span>}
                    {showPublishedLabel && date}
                </p>

                <h1 className="md:text-5xl !leading-tight pt-4 pb-6 font-semibold">
                    {title}
                </h1>
                <p className=" text-gray-dark">{subtitle}</p>
                {categories &&
                    categories.map((cat) => (
                        <Link
                            href="/blog/kategorija/[slug]"
                            as={`/blog/kategorija/${cat.slug?.current}`}
                        >
                            <a>
                                <span
                                    key={cat._id}
                                    className="inline-block bg-violet-200 text-violet-800 text-sm px-4 py-1 rounded-full md:ml-3 md:mr-0 mr-3 "
                                >
                                    {cat.title}
                                </span>
                            </a>
                        </Link>
                    ))}
            </div>
        </section>
    );
}
